import { useRouter } from 'next/router'
import { ChangeEventHandler, KeyboardEventHandler, useState } from 'react'
import { useAppContext } from '../context/siteMapContext'
import { WebMenuTypeEnum } from '../interfaces/webMenu';

const SearchField: React.FC<{ searchPlaceholder: string, value: string, search: (term: string) => void }> = ({
  searchPlaceholder,
  value = '',
  search
}) => {
  const { activePage, highContrastOn } = useAppContext();
  const router = useRouter()

  const [input, setInput] = useState<string>(value)

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event): void => {
    const { target } = event
    const { value } = target as HTMLInputElement
    setInput(value)
  }

  const navigateToSearchPage = () => {
    if (activePage?.type !== WebMenuTypeEnum.SEARCH) {
      router.replace('search', `kereses?kifejezes=${input}`)
    } else {
      search(input);
    }
  }

  const handleSearch: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key == 'Enter') {
      navigateToSearchPage()
    }
  }

  const handleClick = () => {
    navigateToSearchPage()
  }

  return (
    <div className='h-auto w-full relative text-black'>
      <input
        placeholder={searchPlaceholder}
        type='text'
        name='search'
        id='search'
        value={input}
        onChange={handleChange}
        onKeyDown={handleSearch}
        className='h-16 2xl:h-[70px] w-full px-4 border-[2px] rounded-full border-page-title-color bg-white-100 focus:outline-0 text-searchField'
      />
      <div
        onClick={handleClick}
        className={`absolute inset-y-[4px] right-[4px] 2xl:inset-y-[4px] 2xl:right-[4px] h-[32px] 2xl:h-[62px] w-[32px] 2xl:w-[62px] cursor-pointer bg-[url('../public/header/search_icon.svg')] bg-no-repeat bg-right bg-origin-content ${highContrastOn ? 'grayscale' : ''}`}
      />
    </div>
  )
}

export default SearchField
